export const view = {
    methods:{
        submit: function(){
            var _self = this;
            var parameters = this.getFormModel('Profile');
            parameters.ID = this.getForm('Profile').getAttribute('data-id');
            parameters.FranchiseID = localStorage.franchiseID;
            this.$ooApi.orders.accounts.update.v1(parameters).then(function(response){
                _self.showToaster('Success', response.data.message, 'success');
            })
            // check .catch
        },
        changePassword: function(){
            this.$router.push('PasswordChange');
        }
    }
}